import { render, staticRenderFns } from "./tablist3.vue?vue&type=template&id=6f675db7&scoped=true&"
import script from "./tablist3.vue?vue&type=script&lang=js&"
export * from "./tablist3.vue?vue&type=script&lang=js&"
import style0 from "./tablist3.vue?vue&type=style&index=0&id=6f675db7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f675db7",
  null
  
)

export default component.exports